/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SubscriberQuestionnaireItemDto } from './SubscriberQuestionnaireItemDto';

export type CreateSubscriberDto = {
    name?: string;
    email?: string;
    phoneNumber?: string;
    subscribe?: boolean;
    questionnaire: Array<SubscriberQuestionnaireItemDto>;
    language: CreateSubscriberDto.language;
    wantsToBeContacted?: boolean;
};

export namespace CreateSubscriberDto {

    export enum language {
        EN = 'en',
        SV = 'sv',
        DE = 'de',
        DA = 'da',
    }


}

